import React, { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Loader from '../Components/Loader/Loader';
const LazyHomePage = React.lazy(() => import("../Pages/LandingPage/LandingPage"));
const LazyThankYouPage = React.lazy(() => import("../Pages/ThankYou/ThankYou"));
const LazyNotFoundPage = React.lazy(() => import("../Pages/NotFound/NotFound"));

export interface IRouterProps { };


const Router: React.FunctionComponent<IRouterProps> = (props) => {
    return <BrowserRouter>
        <Suspense fallback={<Loader />}>
            <Routes>
                <Route path="/wizard" element={<LazyHomePage />} />
                <Route path="/wizard/end" element={<LazyThankYouPage />} />
                <Route path="/" element={<Navigate replace to="/wizard" />} />
                <Route path="*" element={<LazyNotFoundPage />} />
            </Routes>
        </Suspense>
    </BrowserRouter>
}
export default Router;